import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Category from './Category';
import { getContentGroupData } from '../../../redux/data/selectors';

class Categories extends React.Component {
    constructor (props) {
        super(props)
    }

    render () {
        const { isAssignedGroup, assignedCategories } = this.props
        let rendered = (this.props.term === '') ?
            this.renderNested() :
            this.renderFiltered();
        
        // if this user is assigned to content groups hide all categories that aren't included in one of their content groups
        // unless they are a parent category which has an assigned child category
        if (isAssignedGroup) {
            rendered = rendered.filter(component => {
                return assignedCategories.some(category => {
                    const componentCatID = component.props.category.categoryID
                    if (category.categoryID == componentCatID) {
                        return true
                    }
                    if (assignedCategories.some(category => category.childOf === componentCatID)) {
                        // a child of this parent category is assigned
                        return true
                    }
                })
            })
        }

        return (<div>{
            rendered.length ?
                rendered :
                <div className="alert alert-warning">
                    <p><strong><i>No Assignable Categories</i></strong></p>
                    <p><Link to="/manage/categories">Create and Manage them here &hellip;</Link></p>
                </div>
        }</div>);
    }

    renderCategory (category) {
        var { assigned, actions, nested, mode, assignCategoryToEvent, term } = this.props;

        var properties = {
            key: 'category-' + category.categoryID,
            category: category,
            actions: actions,
            nested: nested[category.categoryID] || false,
            term: term,
            mode: mode,
            assigned: assigned,
            isParent: (function () {
                return nested.hasOwnProperty(category.categoryID);
            })()
        };

        if (mode == 'event') {
            properties.assignCategoryToEvent = assignCategoryToEvent;
        }

        return <Category {...this.props} {...properties}/>;
    }

    /**
     * This renders all parent categories (who in turn render their children),
     * but if a parent category has been assigned to an event, this will also
     * list all child categories independent of the parent.
     *
     * @return {Array}  The rendered Parent Categories.
     */
    renderNested () {
        var rendered = [];
        var renderedChildren = [];
        var { nested } = this.props;

        // For all categories in state
        for (var i = 0; i < this.props.categories.length; i++) {
            var category = this.props.categories[i];

            // If the category isn't assigned to the event
            if (!this.assigned(category)) {
                // If the category either doesn't have a parent or the parent is assigned
                if (category.parentCategoryID === null) {
                    rendered.push(this.renderCategory(category));
                } else if (this.assigned(category.parentCategoryID)) {
                    // If the child's parent category is also assigned to the event

                    // Collect the children
                    var parent = nested[category.parentCategoryID];

                    // Loop through them and render as "parents", but only do it
                    // once for each child if they are not assigned
                    for (var child in parent) {
                        if (
                            parent.hasOwnProperty(child) &&
                            renderedChildren.indexOf(child) === -1 &&
                            !this.assigned(parent[child])
                        ) {
                            // Track which children we have rendered so we don't
                            // render them once ever loop
                            renderedChildren.push(child);
                            rendered.push(this.renderCategory(parent[child]));
                        }
                    }
                }
            }
        }

        return rendered;
    }

    renderFiltered () {
        var rendered = [];
        for (var i = 0; i < this.props.categories.length; i++) {
            var category = this.props.categories[i];
            if (category['categoryName'].toLowerCase().indexOf(this.props.term) >= 0 && !this.assigned(category)) {
                rendered.push(this.renderCategory(category));
            }
        }
        return rendered;
    }

    assigned (category) {
        if (this.props.mode == 'event') {
            if (typeof category === 'object') {
                return this.props.assigned.indexOf(category.categoryName) > -1;
            } else if (typeof category === 'string') {
                for (var i = 0; i < this.props.categories.length; i++) {
                    if (this.props.categories[i].categoryID == category) {
                        return (this.props.assigned.indexOf(
                            this.props.categories[i].categoryName
                        ) > -1);
                    }
                }
            }
        }
        return false;
    }
}

const mapStateToProps = state => {
    const { contentGroups, categories } = getContentGroupData(state)
    const isAssignedGroup = contentGroups.length
    return { isAssignedGroup, assignedCategories: categories}
}

export default connect(mapStateToProps)(Categories);
